import React from 'react';
import classNames from 'classnames'
import AvatarBase from 'react-avatar'
const Avatar = AvatarBase as React.ComponentType<{ color?: string; className?: string; name?: string; textSizeRatio?: number; size?: string; round?: boolean }>
import { Transition, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { useUserService } from '../../../services/User'

interface UserNavigationItem {
  name: string
  href?: string
  onClick?: () => void
}

interface UserMenuProps {
  dropdownPosition?: string
  currentProduct?: string
  userNavigation: UserNavigationItem[]
  userNamePostfix?: string
}

const UserMenu = ({ dropdownPosition = 'bottomLeft', currentProduct = '', userNavigation, userNamePostfix }: UserMenuProps) => {
  const { user, isUserInRole } = useUserService(window?.config?.iam_service_url ?? '', window?.config?.session_cookie ?? '', currentProduct)
  const isVendorRole = isUserInRole('sustain:vendor')

  return (
    <Menu as="div" className="block relative">
      {({ open }) => (
        <>
          <div data-cy="profile-button">
            <MenuButton
              className="bg-white flex text-sm focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-perfect-shine">
              <Avatar color="transparent" className="bg-pacific-storm" name={user.full_name}
                textSizeRatio={2} size="40" />
            </MenuButton>
          </div>
          <Transition
            show={open}
            enter="transition ease-out duration-200"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <MenuItems
              static
              className={classNames(
                "z-50 absolute mt-2 w-52 rounded-md shadow-lg bg-white ring-1 ring-black/5 focus:outline-hidden",
                dropdownPosition === 'bottomLeft'
                  ? "origin-top-right right-0 bottom-0"
                  : "origin-top-left right-0 top-full"
              )}
            >
              <MenuItem as="span"
                className="truncate cursor-default text-white rounded-t-md bg-pacific-storm block px-4 pt-2 text-xs">
                {user.full_name} {userNamePostfix && `(${userNamePostfix})`}
              </MenuItem>
              <MenuItem as="span"
                className="truncate cursor-default text-white bg-pacific-storm block px-4 pb-2 text-xs">
                {isVendorRole
                  ? String(user.metadata?.vendor_name ?? '')
                  : user.entity_name}
              </MenuItem>
              {userNavigation.map((item) => (
                <MenuItem
                  key={item.name}>
                  {({ active }) => (
                    <a
                      data-cy={`${item.name.replace(/\s+/g, '-').toLowerCase()}-menu-item`}
                      href={item.href}
                      onClick={item.onClick}
                      className={classNames(
                        active ? 'bg-gray-100' : '',
                        'block px-4 py-2 text-sm text-gray-700 cursor-pointer'
                      )}
                    >
                      {item.name}
                    </a>
                  )}
                </MenuItem>
              ))}
            </MenuItems>
          </Transition>
        </>
      )}
    </Menu >
  );
};

export default UserMenu;
